import React, { FC, useEffect } from "react";
import * as NavigationActions from '../../actions/navigation';
import { RestrictedLayout } from "../../components/layouts";
import * as Dtos from "../../dtos/Tmd.dtos";
import { SettingsBreadcrumbs } from "../../helpers/breadcrumbHelper";
import { SettingsSubMenu } from "../../helpers/subMenuHelper";
import useDispatch, { useActionCreator } from "../../hooks/useDispatch";
import useSelector from "../../hooks/useSelector";
import SettingsCard from "./SettingsCard";

import './SettingsPage.scss';

const Settings: FC = () => {
    // Menu items
    const permissions = useSelector(state => state.user.userSummary?.permissions ?? []);
    const menuItems = SettingsSubMenu(permissions);
    
    // Breadcrumbs
    const breadcrumbs = SettingsBreadcrumbs();

    const dispatch = useDispatch();
    const setDrawerItems = useActionCreator(NavigationActions.SetDrawerItems, dispatch);
    const setBreadcrumbs = useActionCreator(NavigationActions.SetBreadcrumbs, dispatch);

    useEffect(() => {
        setDrawerItems([]);
        setBreadcrumbs(breadcrumbs);
    }, [setDrawerItems, setBreadcrumbs]);

    const renderSettingsCards = () => {
        return menuItems?.filter(x => x.description)?.map((item, index) => (
            <SettingsCard 
                key={`item-${item.title}-${index}`}
                navItem={item}
            />
        ));
    }

    return (
        <RestrictedLayout
            permission={Dtos.Permission.SettingsView}
        >
            <div className="settings-page">
                <div className="settings-container">
                    <h1 className="mb-4">Settings</h1>
                    <div className="settings-grid">
                        {renderSettingsCards()}
                    </div>
                </div>
            </div>
        </RestrictedLayout>
    );
}


export default Settings;